module.exports = __webpack_public_path__ + "static/index/img/baikal-900.e06b344a.jpg";